import { useRef, useEffect, useState, useCallback } from "react";

export function Image(props) {
  const { onLoad=() => {}, fallbackSrc="", src="", style={}, ...imgAttrs } = props;
  const ref = useRef(null);
  const [imageSrc, setImageSrc] = useState(src);
  const [loadStatus, setLoadStatus] = useState("loading");

  // const imageStyle = loadStatus === "loading" 
  //   ? {...style, display: "none"}
  //   : {display: "inline", ...style};
  const imageStyle = style;

  const imageOnLoad = useCallback(() => {
    setLoadStatus("complete");
    onLoad("complete");
  }, [onLoad]);

  const imageOnError = useCallback(() => {
    setImageSrc(fallbackSrc);
    setLoadStatus("error");
    onLoad("error");
  }, [onLoad]);

  useEffect(() => {
    ref.current.addEventListener("load", imageOnLoad);
    ref.current.addEventListener("error", imageOnError);

    return () => {
      ref?.current?.removeEventListener("load", imageOnLoad);
      ref?.current?.removeEventListener("error", imageOnError);
    }
  }, [ref]);


  return (
    <img ref={ref} src={imageSrc} style={imageStyle} {...imgAttrs} />
  );
}

export default Image;